import styled from '@emotion/styled';

export const BlanketWrapper = styled.div`
  z-index: 501;
`;
